import Axios from 'axios';
import CryptoAES from 'crypto-js/aes';
import CryptoENC from 'crypto-js/enc-utf8';



const ENC_KEY = "D0b@r@matpuchn@k1P@55w0rdkyaha1";
const API_URL = 'https://api.aignt.in/';
const tkn = localStorage.getItem('token');



let AuthStr = '--';
let bbAuthStr = '--';
if (tkn) {
    // console.log('---------');
    // console.log(tkn);
    // console.log('---0-----');

    AuthStr = tkn;
    bbAuthStr = `Bearer ${tkn}`;

}





class Apiconnect {




    encrypt = (txt) => {
        var _ciphertext = CryptoAES.encrypt(txt, ENC_KEY).toString();
        return _ciphertext;
    }
    encrypt_obj = (txt) => {
        var _ciphertext = CryptoAES.encrypt(JSON.stringify(txt), ENC_KEY).toString();
        return _ciphertext;
    }



    decrypt = (ciphertext) => {
        var _ciphertext = CryptoAES.decrypt(ciphertext.toString(), ENC_KEY);
        return _ciphertext.toString(CryptoENC);
    }
    decrypt_obj = (ciphertext) => {
        var _ciphertext = CryptoAES.decrypt(ciphertext.toString(), ENC_KEY);
        return JSON.parse(_ciphertext.toString(CryptoENC));

    }

    getData(urlpart) {
        //console.warn(AuthStr);
        //console.warn(API_URL+urlpart);
        return Axios.get(API_URL + urlpart, { headers: { authorization: AuthStr } });
    }

    getData1(urlpart, token) {
        return Axios.get(API_URL + urlpart, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }


    getDataAuth(urlpart) {

        //var _ciphertext = CryptoAES.decrypt(AuthStr.toString(), ENC_KEY);
        //var tokkken = _ciphertext.toString(CryptoENC); 
        // console.log('-----');
        // console.log(AuthStr);
        // console.log(tokkken);
        // console.log('---XXX--');


        return Axios.get(API_URL + urlpart, {
            headers: {
                Authorization: `Bearer ${AuthStr}`
            }
        });


    }
    getData_arr(urlpart, data) {
        return Axios.get(API_URL + urlpart, data, { headers: { authorization: AuthStr } });
    }

    postData(urlpart, data) {

        // var ttt = 'Bearer ' + token;

        return Axios.post(API_URL + urlpart, data, {
            headers: {
                'authorization': bbAuthStr,
                'Content-Type': 'application/json'
            }
        });
    }

    postDataWithToken(urlpart, token, data) {
        var ttt = 'Bearer ' + token;

        return Axios.post(API_URL + urlpart, data, {
            headers: {
                'authorization': ttt,
                'Content-Type': 'application/json'  // Explicitly set content type
            }
        });
    }


    getDataNoauth(urlpart) {
        // console.warn(AuthStr);
        console.warn(API_URL + urlpart);
        // console.warn(data);
        return Axios.get(API_URL + urlpart);
    }

    postDataNoauth(urlpart, data) {
        console.warn(API_URL + urlpart); console.warn(data);
        return Axios.post(API_URL + urlpart, data);
    }



    postDataAuth(urlpart, data) {
        console.warn(API_URL + urlpart); console.warn(data);
        return Axios.post(API_URL + urlpart, data, {
            headers: {
                'Content-Type': 'application/json',

            }
        });




    }







    deleteData(urlpart) {
        return Axios.delete(API_URL + urlpart, { headers: { authorization: AuthStr } });
    }



}
var api = new Apiconnect();
export default api; 